import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/gluestack/text';
import type { IMediaItem, IMediaRenderOptions } from '@/models/Media';
import { mediaRegistry } from '@/services/media/registry';

interface IMediaViewProps {
  item: IMediaItem;
  rounded?: boolean;
  maxWidth?: number;
}

export function MediaView({ item, rounded = true, maxWidth }: IMediaViewProps) {
  const { t } = useTranslation();
  const renderOptions: IMediaRenderOptions = { rounded, maxWidth };

  const provider = mediaRegistry.get(item.Provider);
  if (provider) {
    return <>{provider.renderItem(item, renderOptions)}</>;
  }

  return (
    <Text size="sm" className="text-typography-500">
      {t('media.failed_to_load')}
    </Text>
  );
}
